// extracted by mini-css-extract-plugin
export default {"group":"Group-module__[local]___Pi95-","active":"Group-module__[local]___jt4mP","on":"Group-module__[local]___quIkp","off":"Group-module__[local]___5hFU4"};